import { useContext } from "react";
import { ShortcutsContext } from "../ShortcutsContext";

export default function useShortcuts() {
  const { open, setOpen } = useContext(ShortcutsContext);
  return { open, setOpen } as const;
}
